import { Component, computed, input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ImageMetadata } from 'app/shared/models/image-metadata.model';

@Component({
  selector: 'ez-footer',
  imports: [ReactiveFormsModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  //background color is determined by --tertiary-background-color variable
  readonly assetBucketUrl = input.required<string>();
  readonly imprintUrl = input.required<string>();
  readonly dataPrivacyUrl = input.required<string>();
  readonly imageData = input.required<ImageMetadata>();
  readonly organisationName = input.required<string>();

  readonly prefixedImprintUrl = computed(() =>
    this.imprintUrl().startsWith('www') ? 'https://' + this.imprintUrl() : this.imprintUrl(),
  );
  readonly prefixedDataPrivacyUrl = computed(() =>
    this.dataPrivacyUrl().startsWith('www') ? 'https://' + this.dataPrivacyUrl() : this.dataPrivacyUrl(),
  );
  readonly altText = computed(() => this.imageData().imgAltText || `Alternativ-Logo ${this.organisationName()}`);
  readonly imgSrc = computed(() => this.assetBucketUrl() + this.imageData().imgSrc);
  readonly imgWidth = computed(() => this.imageData().imgWidth);
  readonly imgHeight = computed(() => this.imageData().imgHeight);
}
